export const AI_TEMPLATE_NAME = 'AI Note';
export const AI_SECTION_TYPE = 'ai-generated';
